import { FC } from 'react';
import { ReturnListItem } from './item';
import { ReturnSectionListProps } from './type';

const ReturnSectionListWrapper: FC<ReturnSectionListProps> = ({ list, isOpen, hideCount }) => {
  if (isOpen) {
    return <></>;
  }
  return list?.map((item) => {
    return <ReturnListItem key={item.id} toolOrder={item} hideCount={hideCount} />;
  });
};

export default ReturnSectionListWrapper;
